import * as PropTypes from "prop-types";
import NoMatch from "./NoMatch.svg";
import Icon from "./Icon";

export default function NoMatchIcon({ className, style, onClick }) {
  const localStyle = {
    height: "1.5rem",
    width: "1.5rem",
    position: "relative",
    left: "-25%",
    ...style,
  };

  return (
    <Icon
      src={NoMatch}
      className={className}
      style={localStyle}
      onClick={onClick}
    />
  );
}

NoMatchIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

NoMatchIcon.defaultProps = {
  className: "",
  style: {},
};
